module.exports = __webpack_public_path__ + "img/go2.93709578.png";